/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AvailableCountCompareBy } from '../api-models';
// @ts-ignore
import { BaseResponseOfAvailableSchedulesReportResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfCalloffsResponse } from '../api-models';
// @ts-ignore
import { FacilityOpenshiftEmployeeAggregateResponse } from '../api-models';
// @ts-ignore
import { FileFormat } from '../api-models';
// @ts-ignore
import { GetDailyStaffingSheetRequest } from '../api-models';
// @ts-ignore
import { GetSavedReportsResponse } from '../api-models';
// @ts-ignore
import { GetUserReportFiltersResponse } from '../api-models';
// @ts-ignore
import { GroupBy } from '../api-models';
// @ts-ignore
import { MasterScheduleReportDataResponse } from '../api-models';
// @ts-ignore
import { Orientation } from '../api-models';
// @ts-ignore
import { PageModelOfFacilityAggregateResponse } from '../api-models';
// @ts-ignore
import { ReportExportData } from '../api-models';
// @ts-ignore
import { ReportFilterRequest } from '../api-models';
// @ts-ignore
import { ReportResponse } from '../api-models';
// @ts-ignore
import { SaveReportRequest } from '../api-models';
// @ts-ignore
import { SaveReportResponse } from '../api-models';
// @ts-ignore
import { SaveUserReportFiltersRequest } from '../api-models';
/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsAbsenceReportGet: async (startDate: string, endDate: string, departmentId?: number, positionId?: number, employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('reportsAbsenceReportGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('reportsAbsenceReportGet', 'endDate', endDate)
            const localVarPath = `/Reports/absence-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} shiftTypeId 
         * @param {number} positionId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [facilityId] 
         * @param {AvailableCountCompareBy} [availableCountCompareBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsAvailableSchedulesReportGet: async (departmentId: number, shiftTypeId: number, positionId: number, startDate: string, endDate: string, facilityId?: number, availableCountCompareBy?: AvailableCountCompareBy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('reportsAvailableSchedulesReportGet', 'departmentId', departmentId)
            // verify required parameter 'shiftTypeId' is not null or undefined
            assertParamExists('reportsAvailableSchedulesReportGet', 'shiftTypeId', shiftTypeId)
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('reportsAvailableSchedulesReportGet', 'positionId', positionId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('reportsAvailableSchedulesReportGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('reportsAvailableSchedulesReportGet', 'endDate', endDate)
            const localVarPath = `/Reports/available-schedules-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (availableCountCompareBy !== undefined) {
                localVarQueryParameter['availableCountCompareBy'] = availableCountCompareBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {string} date 
         * @param {number} [facilityId] 
         * @param {FileFormat} [format] 
         * @param {GroupBy} [groupBy] 
         * @param {Orientation} [orientation] 
         * @param {string} [header] 
         * @param {string} [footer] 
         * @param {boolean} [hppdByPosition] 
         * @param {boolean} [compact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDailyStaffingSheetDataGet: async (departmentId: number, date: string, facilityId?: number, format?: FileFormat, groupBy?: GroupBy, orientation?: Orientation, header?: string, footer?: string, hppdByPosition?: boolean, compact?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('reportsDailyStaffingSheetDataGet', 'departmentId', departmentId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('reportsDailyStaffingSheetDataGet', 'date', date)
            const localVarPath = `/Reports/daily-staffing-sheet-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['groupBy'] = groupBy;
            }

            if (orientation !== undefined) {
                localVarQueryParameter['orientation'] = orientation;
            }

            if (header !== undefined) {
                localVarQueryParameter['header'] = header;
            }

            if (footer !== undefined) {
                localVarQueryParameter['footer'] = footer;
            }

            if (hppdByPosition !== undefined) {
                localVarQueryParameter['hppdByPosition'] = hppdByPosition;
            }

            if (compact !== undefined) {
                localVarQueryParameter['compact'] = compact;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetDailyStaffingSheetRequest} [getDailyStaffingSheetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDailyStaffingSheetDataPost: async (getDailyStaffingSheetRequest?: GetDailyStaffingSheetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/daily-staffing-sheet-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDailyStaffingSheetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Report for an Employee from Pay Period or Start Date - End Date  Called from /SaasReports/employee-print
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [schedulePeriodId] 
         * @param {boolean} [usingSchedulePeriod] 
         * @param {number} [employeeId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsEmployeePrintGet: async (startDate?: string, endDate?: string, schedulePeriodId?: number, usingSchedulePeriod?: boolean, employeeId?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/employee-print`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }

            if (usingSchedulePeriod !== undefined) {
                localVarQueryParameter['usingSchedulePeriod'] = usingSchedulePeriod;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsExportEmployeeOpenshiftPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/export-employee-openshift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsFacilityAggregatesPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/facility-aggregates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsFacilityEmployeeAggregatesPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/facility-employee-aggregates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} departmentId 
         * @param {number} [facilityId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [unitId] 
         * @param {number} [positionId] 
         * @param {FileFormat} [format] 
         * @param {number} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsMasterScheduleGet: async (startDate: string, endDate: string, departmentId: number, facilityId?: number, shiftTypeId?: number, unitId?: number, positionId?: number, format?: FileFormat, orderBy?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('reportsMasterScheduleGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('reportsMasterScheduleGet', 'endDate', endDate)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('reportsMasterScheduleGet', 'departmentId', departmentId)
            const localVarPath = `/Reports/master-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} departmentId 
         * @param {number} [shiftTypeId] 
         * @param {number} [unitId] 
         * @param {number} [positionId] 
         * @param {number} [employeeId] 
         * @param {FileFormat} [format] 
         * @param {number} [orderBy] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsMonthlyPrintGet: async (startDate: string, endDate: string, departmentId: number, shiftTypeId?: number, unitId?: number, positionId?: number, employeeId?: number, format?: FileFormat, orderBy?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('reportsMonthlyPrintGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('reportsMonthlyPrintGet', 'endDate', endDate)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('reportsMonthlyPrintGet', 'departmentId', departmentId)
            const localVarPath = `/Reports/monthly-print`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {SaveReportRequest} [saveReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportIdPut: async (id: number, saveReportRequest?: SaveReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reportsSavedReportIdPut', 'id', id)
            const localVarPath = `/Reports/saved-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveReportRequest} [saveReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportPost: async (saveReportRequest?: SaveReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/saved-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} savedReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportSavedReportIdDelete: async (savedReportId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedReportId' is not null or undefined
            assertParamExists('reportsSavedReportSavedReportIdDelete', 'savedReportId', savedReportId)
            const localVarPath = `/Reports/saved-report/{savedReportId}`
                .replace(`{${"savedReportId"}}`, encodeURIComponent(String(savedReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportsReportNameGet: async (reportName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportName' is not null or undefined
            assertParamExists('reportsSavedReportsReportNameGet', 'reportName', reportName)
            const localVarPath = `/Reports/saved-reports/{reportName}`
                .replace(`{${"reportName"}}`, encodeURIComponent(String(reportName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
         * @param {SaveUserReportFiltersRequest} [saveUserReportFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUserReportFiltersPut: async (saveUserReportFiltersRequest?: SaveUserReportFiltersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Reports/user-report-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveUserReportFiltersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUserReportFiltersReportNameGet: async (reportName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportName' is not null or undefined
            assertParamExists('reportsUserReportFiltersReportNameGet', 'reportName', reportName)
            const localVarPath = `/Reports/user-report-filters/{reportName}`
                .replace(`{${"reportName"}}`, encodeURIComponent(String(reportName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsAbsenceReportGet(startDate: string, endDate: string, departmentId?: number, positionId?: number, employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfCalloffsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsAbsenceReportGet(startDate, endDate, departmentId, positionId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} shiftTypeId 
         * @param {number} positionId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [facilityId] 
         * @param {AvailableCountCompareBy} [availableCountCompareBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsAvailableSchedulesReportGet(departmentId: number, shiftTypeId: number, positionId: number, startDate: string, endDate: string, facilityId?: number, availableCountCompareBy?: AvailableCountCompareBy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfAvailableSchedulesReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsAvailableSchedulesReportGet(departmentId, shiftTypeId, positionId, startDate, endDate, facilityId, availableCountCompareBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {string} date 
         * @param {number} [facilityId] 
         * @param {FileFormat} [format] 
         * @param {GroupBy} [groupBy] 
         * @param {Orientation} [orientation] 
         * @param {string} [header] 
         * @param {string} [footer] 
         * @param {boolean} [hppdByPosition] 
         * @param {boolean} [compact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsDailyStaffingSheetDataGet(departmentId: number, date: string, facilityId?: number, format?: FileFormat, groupBy?: GroupBy, orientation?: Orientation, header?: string, footer?: string, hppdByPosition?: boolean, compact?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsDailyStaffingSheetDataGet(departmentId, date, facilityId, format, groupBy, orientation, header, footer, hppdByPosition, compact, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetDailyStaffingSheetRequest} [getDailyStaffingSheetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsDailyStaffingSheetDataPost(getDailyStaffingSheetRequest?: GetDailyStaffingSheetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsDailyStaffingSheetDataPost(getDailyStaffingSheetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Report for an Employee from Pay Period or Start Date - End Date  Called from /SaasReports/employee-print
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [schedulePeriodId] 
         * @param {boolean} [usingSchedulePeriod] 
         * @param {number} [employeeId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsEmployeePrintGet(startDate?: string, endDate?: string, schedulePeriodId?: number, usingSchedulePeriod?: boolean, employeeId?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsEmployeePrintGet(startDate, endDate, schedulePeriodId, usingSchedulePeriod, employeeId, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsExportEmployeeOpenshiftPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportExportData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsExportEmployeeOpenshiftPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsFacilityAggregatesPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageModelOfFacilityAggregateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsFacilityAggregatesPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsFacilityEmployeeAggregatesPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityOpenshiftEmployeeAggregateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsFacilityEmployeeAggregatesPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} departmentId 
         * @param {number} [facilityId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [unitId] 
         * @param {number} [positionId] 
         * @param {FileFormat} [format] 
         * @param {number} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsMasterScheduleGet(startDate: string, endDate: string, departmentId: number, facilityId?: number, shiftTypeId?: number, unitId?: number, positionId?: number, format?: FileFormat, orderBy?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterScheduleReportDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsMasterScheduleGet(startDate, endDate, departmentId, facilityId, shiftTypeId, unitId, positionId, format, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} departmentId 
         * @param {number} [shiftTypeId] 
         * @param {number} [unitId] 
         * @param {number} [positionId] 
         * @param {number} [employeeId] 
         * @param {FileFormat} [format] 
         * @param {number} [orderBy] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsMonthlyPrintGet(startDate: string, endDate: string, departmentId: number, shiftTypeId?: number, unitId?: number, positionId?: number, employeeId?: number, format?: FileFormat, orderBy?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsMonthlyPrintGet(startDate, endDate, departmentId, shiftTypeId, unitId, positionId, employeeId, format, orderBy, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {SaveReportRequest} [saveReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsSavedReportIdPut(id: number, saveReportRequest?: SaveReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsSavedReportIdPut(id, saveReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SaveReportRequest} [saveReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsSavedReportPost(saveReportRequest?: SaveReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsSavedReportPost(saveReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} savedReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsSavedReportSavedReportIdDelete(savedReportId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsSavedReportSavedReportIdDelete(savedReportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsSavedReportsReportNameGet(reportName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSavedReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsSavedReportsReportNameGet(reportName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
         * @param {SaveUserReportFiltersRequest} [saveUserReportFiltersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsUserReportFiltersPut(saveUserReportFiltersRequest?: SaveUserReportFiltersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsUserReportFiltersPut(saveUserReportFiltersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
         * @param {string} reportName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportsUserReportFiltersReportNameGet(reportName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserReportFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportsUserReportFiltersReportNameGet(reportName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {ReportsApiReportsAbsenceReportGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsAbsenceReportGet(requestParameters: ReportsApiReportsAbsenceReportGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfCalloffsResponse> {
            return localVarFp.reportsAbsenceReportGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.positionId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsAvailableSchedulesReportGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsAvailableSchedulesReportGet(requestParameters: ReportsApiReportsAvailableSchedulesReportGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfAvailableSchedulesReportResponse> {
            return localVarFp.reportsAvailableSchedulesReportGet(requestParameters.departmentId, requestParameters.shiftTypeId, requestParameters.positionId, requestParameters.startDate, requestParameters.endDate, requestParameters.facilityId, requestParameters.availableCountCompareBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsDailyStaffingSheetDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDailyStaffingSheetDataGet(requestParameters: ReportsApiReportsDailyStaffingSheetDataGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportsDailyStaffingSheetDataGet(requestParameters.departmentId, requestParameters.date, requestParameters.facilityId, requestParameters.format, requestParameters.groupBy, requestParameters.orientation, requestParameters.header, requestParameters.footer, requestParameters.hppdByPosition, requestParameters.compact, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsDailyStaffingSheetDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDailyStaffingSheetDataPost(requestParameters: ReportsApiReportsDailyStaffingSheetDataPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportsDailyStaffingSheetDataPost(requestParameters.getDailyStaffingSheetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Report for an Employee from Pay Period or Start Date - End Date  Called from /SaasReports/employee-print
         * @param {ReportsApiReportsEmployeePrintGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsEmployeePrintGet(requestParameters: ReportsApiReportsEmployeePrintGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportsEmployeePrintGet(requestParameters.startDate, requestParameters.endDate, requestParameters.schedulePeriodId, requestParameters.usingSchedulePeriod, requestParameters.employeeId, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsExportEmployeeOpenshiftPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsExportEmployeeOpenshiftPost(requestParameters: ReportsApiReportsExportEmployeeOpenshiftPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ReportExportData>> {
            return localVarFp.reportsExportEmployeeOpenshiftPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsFacilityAggregatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsFacilityAggregatesPost(requestParameters: ReportsApiReportsFacilityAggregatesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PageModelOfFacilityAggregateResponse> {
            return localVarFp.reportsFacilityAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsFacilityEmployeeAggregatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsFacilityEmployeeAggregatesPost(requestParameters: ReportsApiReportsFacilityEmployeeAggregatesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<FacilityOpenshiftEmployeeAggregateResponse> {
            return localVarFp.reportsFacilityEmployeeAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsMasterScheduleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsMasterScheduleGet(requestParameters: ReportsApiReportsMasterScheduleGetRequest, options?: AxiosRequestConfig): AxiosPromise<MasterScheduleReportDataResponse> {
            return localVarFp.reportsMasterScheduleGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.facilityId, requestParameters.shiftTypeId, requestParameters.unitId, requestParameters.positionId, requestParameters.format, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsMonthlyPrintGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsMonthlyPrintGet(requestParameters: ReportsApiReportsMonthlyPrintGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportsMonthlyPrintGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.shiftTypeId, requestParameters.unitId, requestParameters.positionId, requestParameters.employeeId, requestParameters.format, requestParameters.orderBy, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsPost(requestParameters: ReportsApiReportsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ReportResponse>> {
            return localVarFp.reportsPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsSavedReportIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportIdPut(requestParameters: ReportsApiReportsSavedReportIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<SaveReportResponse> {
            return localVarFp.reportsSavedReportIdPut(requestParameters.id, requestParameters.saveReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsSavedReportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportPost(requestParameters: ReportsApiReportsSavedReportPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SaveReportResponse> {
            return localVarFp.reportsSavedReportPost(requestParameters.saveReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsSavedReportSavedReportIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportSavedReportIdDelete(requestParameters: ReportsApiReportsSavedReportSavedReportIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportsSavedReportSavedReportIdDelete(requestParameters.savedReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportsApiReportsSavedReportsReportNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsSavedReportsReportNameGet(requestParameters: ReportsApiReportsSavedReportsReportNameGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetSavedReportsResponse> {
            return localVarFp.reportsSavedReportsReportNameGet(requestParameters.reportName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
         * @param {ReportsApiReportsUserReportFiltersPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUserReportFiltersPut(requestParameters: ReportsApiReportsUserReportFiltersPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportsUserReportFiltersPut(requestParameters.saveUserReportFiltersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
         * @param {ReportsApiReportsUserReportFiltersReportNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUserReportFiltersReportNameGet(requestParameters: ReportsApiReportsUserReportFiltersReportNameGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserReportFiltersResponse> {
            return localVarFp.reportsUserReportFiltersReportNameGet(requestParameters.reportName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reportsAbsenceReportGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsAbsenceReportGetRequest
 */
export interface ReportsApiReportsAbsenceReportGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsAbsenceReportGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsAbsenceReportGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAbsenceReportGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAbsenceReportGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAbsenceReportGet
     */
    readonly employeeId?: number
}

/**
 * Request parameters for reportsAvailableSchedulesReportGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsAvailableSchedulesReportGetRequest
 */
export interface ReportsApiReportsAvailableSchedulesReportGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly departmentId: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly shiftTypeId: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly positionId: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {AvailableCountCompareBy}
     * @memberof ReportsApiReportsAvailableSchedulesReportGet
     */
    readonly availableCountCompareBy?: AvailableCountCompareBy
}

/**
 * Request parameters for reportsDailyStaffingSheetDataGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsDailyStaffingSheetDataGetRequest
 */
export interface ReportsApiReportsDailyStaffingSheetDataGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly departmentId: number

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly date: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {FileFormat}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly format?: FileFormat

    /**
     * 
     * @type {GroupBy}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly groupBy?: GroupBy

    /**
     * 
     * @type {Orientation}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly orientation?: Orientation

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly header?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly footer?: string

    /**
     * 
     * @type {boolean}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly hppdByPosition?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ReportsApiReportsDailyStaffingSheetDataGet
     */
    readonly compact?: boolean
}

/**
 * Request parameters for reportsDailyStaffingSheetDataPost operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsDailyStaffingSheetDataPostRequest
 */
export interface ReportsApiReportsDailyStaffingSheetDataPostRequest {
    /**
     * 
     * @type {GetDailyStaffingSheetRequest}
     * @memberof ReportsApiReportsDailyStaffingSheetDataPost
     */
    readonly getDailyStaffingSheetRequest?: GetDailyStaffingSheetRequest
}

/**
 * Request parameters for reportsEmployeePrintGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsEmployeePrintGetRequest
 */
export interface ReportsApiReportsEmployeePrintGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsEmployeePrintGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsEmployeePrintGet
     */
    readonly endDate?: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsEmployeePrintGet
     */
    readonly schedulePeriodId?: number

    /**
     * 
     * @type {boolean}
     * @memberof ReportsApiReportsEmployeePrintGet
     */
    readonly usingSchedulePeriod?: boolean

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsEmployeePrintGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsEmployeePrintGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for reportsExportEmployeeOpenshiftPost operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsExportEmployeeOpenshiftPostRequest
 */
export interface ReportsApiReportsExportEmployeeOpenshiftPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof ReportsApiReportsExportEmployeeOpenshiftPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * Request parameters for reportsFacilityAggregatesPost operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsFacilityAggregatesPostRequest
 */
export interface ReportsApiReportsFacilityAggregatesPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof ReportsApiReportsFacilityAggregatesPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * Request parameters for reportsFacilityEmployeeAggregatesPost operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsFacilityEmployeeAggregatesPostRequest
 */
export interface ReportsApiReportsFacilityEmployeeAggregatesPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof ReportsApiReportsFacilityEmployeeAggregatesPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * Request parameters for reportsMasterScheduleGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsMasterScheduleGetRequest
 */
export interface ReportsApiReportsMasterScheduleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly departmentId: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly shiftTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly unitId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {FileFormat}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly format?: FileFormat

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMasterScheduleGet
     */
    readonly orderBy?: number
}

/**
 * Request parameters for reportsMonthlyPrintGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsMonthlyPrintGetRequest
 */
export interface ReportsApiReportsMonthlyPrintGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly departmentId: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly shiftTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly unitId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {FileFormat}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly format?: FileFormat

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly orderBy?: number

    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsMonthlyPrintGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for reportsPost operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsPostRequest
 */
export interface ReportsApiReportsPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof ReportsApiReportsPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * Request parameters for reportsSavedReportIdPut operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsSavedReportIdPutRequest
 */
export interface ReportsApiReportsSavedReportIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsSavedReportIdPut
     */
    readonly id: number

    /**
     * 
     * @type {SaveReportRequest}
     * @memberof ReportsApiReportsSavedReportIdPut
     */
    readonly saveReportRequest?: SaveReportRequest
}

/**
 * Request parameters for reportsSavedReportPost operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsSavedReportPostRequest
 */
export interface ReportsApiReportsSavedReportPostRequest {
    /**
     * 
     * @type {SaveReportRequest}
     * @memberof ReportsApiReportsSavedReportPost
     */
    readonly saveReportRequest?: SaveReportRequest
}

/**
 * Request parameters for reportsSavedReportSavedReportIdDelete operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsSavedReportSavedReportIdDeleteRequest
 */
export interface ReportsApiReportsSavedReportSavedReportIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportsApiReportsSavedReportSavedReportIdDelete
     */
    readonly savedReportId: number
}

/**
 * Request parameters for reportsSavedReportsReportNameGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsSavedReportsReportNameGetRequest
 */
export interface ReportsApiReportsSavedReportsReportNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsSavedReportsReportNameGet
     */
    readonly reportName: string
}

/**
 * Request parameters for reportsUserReportFiltersPut operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsUserReportFiltersPutRequest
 */
export interface ReportsApiReportsUserReportFiltersPutRequest {
    /**
     * 
     * @type {SaveUserReportFiltersRequest}
     * @memberof ReportsApiReportsUserReportFiltersPut
     */
    readonly saveUserReportFiltersRequest?: SaveUserReportFiltersRequest
}

/**
 * Request parameters for reportsUserReportFiltersReportNameGet operation in ReportsApi.
 * @export
 * @interface ReportsApiReportsUserReportFiltersReportNameGetRequest
 */
export interface ReportsApiReportsUserReportFiltersReportNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportsApiReportsUserReportFiltersReportNameGet
     */
    readonly reportName: string
}

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {ReportsApiReportsAbsenceReportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsAbsenceReportGet(requestParameters: ReportsApiReportsAbsenceReportGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsAbsenceReportGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.positionId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsAvailableSchedulesReportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsAvailableSchedulesReportGet(requestParameters: ReportsApiReportsAvailableSchedulesReportGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsAvailableSchedulesReportGet(requestParameters.departmentId, requestParameters.shiftTypeId, requestParameters.positionId, requestParameters.startDate, requestParameters.endDate, requestParameters.facilityId, requestParameters.availableCountCompareBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsDailyStaffingSheetDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsDailyStaffingSheetDataGet(requestParameters: ReportsApiReportsDailyStaffingSheetDataGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsDailyStaffingSheetDataGet(requestParameters.departmentId, requestParameters.date, requestParameters.facilityId, requestParameters.format, requestParameters.groupBy, requestParameters.orientation, requestParameters.header, requestParameters.footer, requestParameters.hppdByPosition, requestParameters.compact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsDailyStaffingSheetDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsDailyStaffingSheetDataPost(requestParameters: ReportsApiReportsDailyStaffingSheetDataPostRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsDailyStaffingSheetDataPost(requestParameters.getDailyStaffingSheetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Report for an Employee from Pay Period or Start Date - End Date  Called from /SaasReports/employee-print
     * @param {ReportsApiReportsEmployeePrintGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsEmployeePrintGet(requestParameters: ReportsApiReportsEmployeePrintGetRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsEmployeePrintGet(requestParameters.startDate, requestParameters.endDate, requestParameters.schedulePeriodId, requestParameters.usingSchedulePeriod, requestParameters.employeeId, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsExportEmployeeOpenshiftPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsExportEmployeeOpenshiftPost(requestParameters: ReportsApiReportsExportEmployeeOpenshiftPostRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsExportEmployeeOpenshiftPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsFacilityAggregatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsFacilityAggregatesPost(requestParameters: ReportsApiReportsFacilityAggregatesPostRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsFacilityAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsFacilityEmployeeAggregatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsFacilityEmployeeAggregatesPost(requestParameters: ReportsApiReportsFacilityEmployeeAggregatesPostRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsFacilityEmployeeAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsMasterScheduleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsMasterScheduleGet(requestParameters: ReportsApiReportsMasterScheduleGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsMasterScheduleGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.facilityId, requestParameters.shiftTypeId, requestParameters.unitId, requestParameters.positionId, requestParameters.format, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsMonthlyPrintGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsMonthlyPrintGet(requestParameters: ReportsApiReportsMonthlyPrintGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsMonthlyPrintGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.shiftTypeId, requestParameters.unitId, requestParameters.positionId, requestParameters.employeeId, requestParameters.format, requestParameters.orderBy, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsPost(requestParameters: ReportsApiReportsPostRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsSavedReportIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsSavedReportIdPut(requestParameters: ReportsApiReportsSavedReportIdPutRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsSavedReportIdPut(requestParameters.id, requestParameters.saveReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsSavedReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsSavedReportPost(requestParameters: ReportsApiReportsSavedReportPostRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsSavedReportPost(requestParameters.saveReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsSavedReportSavedReportIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsSavedReportSavedReportIdDelete(requestParameters: ReportsApiReportsSavedReportSavedReportIdDeleteRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsSavedReportSavedReportIdDelete(requestParameters.savedReportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportsApiReportsSavedReportsReportNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsSavedReportsReportNameGet(requestParameters: ReportsApiReportsSavedReportsReportNameGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsSavedReportsReportNameGet(requestParameters.reportName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
     * @param {ReportsApiReportsUserReportFiltersPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsUserReportFiltersPut(requestParameters: ReportsApiReportsUserReportFiltersPutRequest = {}, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsUserReportFiltersPut(requestParameters.saveUserReportFiltersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary When a user uses a report, it\'s filters gets saved at backend and whenever he goes to the same screen again,  those filters are loaded automatically
     * @param {ReportsApiReportsUserReportFiltersReportNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsUserReportFiltersReportNameGet(requestParameters: ReportsApiReportsUserReportFiltersReportNameGetRequest, options?: AxiosRequestConfig) {
        return ReportsApiFp(this.configuration).reportsUserReportFiltersReportNameGet(requestParameters.reportName, options).then((request) => request(this.axios, this.basePath));
    }
}
